import { el } from "@dhx/ts-common/dom";
import { getCount } from "./helpers";

export function navItem(item: any, widgetName: string, collapsed?: boolean) {
	const baseClass = " dhx_" + widgetName + "-button";
	return el("button", {
		class: "dhx_button" + baseClass +
			(item.active || item.$activeParent ? baseClass + "--active" : "") +
			(item.disabled ? baseClass + "--disabled" : "") +
			(item.$openIcon ? baseClass + "--select" : "") +
			(item.circle ? baseClass + "--circle" : "") +
			(item.size ? " " + baseClass + "--" + item.size : "") +
			(!item.value && item.icon ? baseClass + "--icon" : "") +
			(item.css ? " " + item.css : ""),
		dhx_id: item.id,
		disabled: item.disabled,
		type: "button"
	}, [
		item.icon && el("span", {
			class: item.icon + baseClass + "__icon"
		}),
		item.html && el("div", {
			"class": baseClass.trim() + "__html",
			".innerHTML": item.html
		}),
		!item.html && item.value && el("span", {
			class: baseClass.trim() + "__text"
		}, item.value),
		item.count > 0 && getCount(item, baseClass + "__count", collapsed),
		item.$openIcon && el("span.dxi.dxi-menu-right", {
			class: baseClass + "__caret"
		})
	]);
}